<template>
	<button
		class="spofaq-searchapp__result-category"
		:disabled="
			category.id === selectedCategory ||
				status !== 'ready' ||
				category.count < 1
		"
		:class="{ active: category.id === selectedCategory }"
		v-on:click="filterCategory(category)"
		
	>
		<span class="spofaq-searchapp__result-category-text">{{ category.name }}({{ category.count }})</span>
	</button>
</template>

<script>
export default {
	name: "Category",
	props: ["category", "selectedCategory", "status"],
	methods: {
		filterCategory(category) {
			this.$emit("filter-category", category);
		}
	}
};
</script>

<style scoped></style>
